export const MONTHLY = 1;
export const ANNUALY = 2;
export const CREDIT_DEBIT_CARD = 1;
export const ACH = 2;
export const CHECKING = 1;
export const SAVINGS = 2;